import { SET_DESTINATIONS_SETTINGS } from 'actions'
import createSettingsReducer from '../utils/create-settings-reducer'

export default createSettingsReducer(SET_DESTINATIONS_SETTINGS, {
  searchFilter: 'View All',
  searchTerm: ''
})
